
// components
import React from 'react';
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import { Archive } from '@mui/icons-material';
import i18n from '../../../i18n';

export default class GatewaysPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicGateways';
        this.Server = this.props.context.getState().server.publicGateways;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'gatewayApi.name'];
        this.showDatePicker = false;
        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'name',
                    label: 'name',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'rule',
                    label: 'rule',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'gatewayApiId',
                    label: 'apiname',
                    alignRight: false,
                    cell: 'Select',
                    object: 'gatewayApi',
                    from: 'publicGatewayApis',
                    show: 'name',
                    displayGrid: true
                },
                {
                    id: 'countries',
                    label: 'countries',
                    alignRight: false,
                    cell: 'ContextMultiSelect',
                    type: 'array',
                    display: 'name',
                    primary: 'name',
                    array: 'countries',
                    from: 'publicCountries',
                    displayGrid: true
                },
                {
                    id: 'settlementPeriod',
                    label: 'settlementPeriod',
                    alignRight: false,
                    cell: 'Number',
                    type: 'number',
                    displayGrid: true
                },
                {
                    id: 'flag',
                    label: 'flag',
                    alignRight: false,
                    cell: 'Items',
                    items: ['p2p', 'payout', 'payment'],
                    displayGrid: true
                },
                {
                    id: 'method',
                    label: 'method',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'providerId',
                    label: 'provider',
                    alignRight: false,
                    cell: 'Select',
                    object: 'provider',
                    from: 'publicProviders',
                    show: 'name',
                    displayGrid: true
                },
                {
                    id: 'isActive',
                    label: 'isActive',
                    alignRight: false,
                    cell: 'EditableBoolean',
                    trueLabel: 'active',
                    falseLabel: 'inactive',
                    confirmFalseLabel: 'confirmActivateGateway',
                    confirmTrueLabel: 'confirmDeactivateGateway',
                    type: 'boolean',
                    displayGrid: true,
                    disableEditor: true,
                    displayAdd: true
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName'
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    customLogicOnMount() {
        this.fs.clearGroup('prefilterBase')
            .addFilter('isArchived', '!=', true, 'prefilterBase', true);
    }


    renderCustomMenuItems() {
        const isItemArchived = this.getMenuClickItemValue('isArchived') === true;

        const isAllowedArchive = this.allowedArchive() && !isItemArchived;
        return [
            isAllowedArchive && (
                <MenuItem
                    key="archive"
                    onClick={() => this.handleArchiveConfirmDialogOpen()}
                >
                    <Archive sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.archive')}
                </MenuItem>
            )
        ];
    }

    handleSaveCell = async (id, isActive) => {
        const res = await this.Server.toggle(id, 'active', isActive);
        if (res.error === 'OK') {
            await this.retrieveData();
            return true;
        }
        this.handleError(res);
        return false;
    };
}

